import {Dialog, DialogBackdrop, DialogPanel, DialogTitle} from '@headlessui/react'
import {CheckIcon, ExclamationTriangleIcon} from '@heroicons/react/24/outline'
import {PrimaryButton} from "./PrimaryButton.tsx";

interface PopupProps {
    open: any,
    onClose: ()=>void,
    onConfirm: ()=>void,
    title: string,
    children: any,
    Icon?: any | null,
    confirmButtonDisplayLabel?: string,
    disableCancelButton?: boolean,
    confirmButtonDisabledMessage?: string,
    confirmButtonDisabled?: boolean,
    variant?: 'default' | 'danger',
    confirmOnEnter?: boolean
}


export default function Popup({
                                  open,
                                  onClose,
                                  onConfirm,
                                  title,
                                  children,
                                  Icon,
                                  confirmButtonDisplayLabel='Enable',
                                    confirmButtonDisabled,
    confirmButtonDisabledMessage,
                                  disableCancelButton=false,
                                  confirmOnEnter=false,
                                  variant='default'} : PopupProps) {
    
    const isDanger = variant === 'danger';
    const defaultIcon = isDanger ? ExclamationTriangleIcon : CheckIcon;
    const DisplayIcon = Icon !== null && Icon !== false ? (Icon || defaultIcon) : null;    
    const iconBgColor = isDanger ? 'bg-red-100' : 'bg-green-100';
    const iconTextColor = isDanger ? 'text-red-600' : 'text-green-600';
    const buttonBgColor = isDanger ? 'bg-red-600 hover:bg-red-500' : 'bg-primary hover:opacity-70';
    const buttonFocusColor = isDanger ? 'focus-visible:outline-red-600' : 'focus-visible:outline-indigo-600';
    const autoFocusedRing = !confirmOnEnter
        ? ''
        : isDanger
            ? 'focus:ring-1 focus:ring-offset-1 focus:ring-red-400'
            : 'focus:ring-1 focus:ring-primary';


    return (
        <Dialog open={!!open} onClose={onClose} className="relative z-50">
            <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />

            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex min-h-full items-end justify-center text-center sm:items-center sm:p-0">
                    <DialogPanel
                        transition
                        className="relative transform overflow-visible rounded-lg bg-white  text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg  data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                    >
                        <div className="flex px-8 py-4 items-center">
                            {DisplayIcon && <div className="w-16 flex-shrink-0">
                                 <div className={`flex size-12 items-center justify-center rounded-full ${iconBgColor}`}>
                                    <DisplayIcon aria-hidden="true" className={`size-6 ${iconTextColor}`}/>
                                </div>
                            </div>}

                            <div className="flex-1">
                                <DialogTitle as="h3" className="text-lg font-semibold text-gray-900">
                                    {title}
                                </DialogTitle>
                                <div className="mt-2 pr-8 overflow-visible">
                                    {children}
                                </div>
                            </div>
                        </div>
                        <div
                            className="p-4 mt-4 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3 border-t-[1px] border-gray-200">

                            {isDanger ? (
                                <button
                                    type="button"
                                    {...(confirmOnEnter ? {'data-autofocus': true} : {})}
                                    onClick={onConfirm}
                                    disabled={confirmButtonDisabled}
                                    className={`inline-flex w-full shadow-sm justify-center rounded-md ${buttonBgColor} px-3 py-2 text-sm font-semibold text-white shadow-sm disabled:hover:opacity-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${buttonFocusColor} ${autoFocusedRing} sm:col-start-2 disabled:opacity-50`}
                                >
                                    {confirmButtonDisplayLabel}
                                </button>
                            ) : (
                                <PrimaryButton onClick={onConfirm} title={confirmButtonDisplayLabel} disabled={confirmButtonDisabled} disabledFeedback={confirmButtonDisabledMessage} autoFocus={confirmOnEnter} className={`inline-flex w-full shadow-sm justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-sm disabled:hover:opacity-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${buttonFocusColor} ${autoFocusedRing} sm:col-start-2`}>
                                </PrimaryButton>
                            )}

                            {!disableCancelButton &&
                            <button
                                type="button"
                                {...(!confirmOnEnter ? {'data-autofocus': true} : {})}
                                onClick={onClose}
                                className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
                            >
                                Annuleren
                            </button>}
                        </div>
                    </DialogPanel>
                </div>
            </div>
        </Dialog>
    )
}
